import progressions from './progressions.js'

function findProgressionsFor (challengeId) {
    let result = []
    for (let progressionName in progressions) {
        if (progressions[progressionName].includes(challengeId)) {
            result.push(progressionName)
        }
    }
    return result
}

export default findProgressionsFor